export interface OrderProperty {
  id: string;
  orderHeaderId: string;
  salesPurchasePropertyId: string;
  key: string;
  heading: string;
  text: boolean;
  boolean: boolean;
  displayText: string;
  true: boolean;
  trueString: string;
}
